
<template>

	<myframe without_border without_margin title="Сранительный подход">

		<biTable class="mt-4" :data="rows">
			<template v-slot:value_params="row">
				<router-link v-if="row.data.title == 'Модель оценки КС'" :to="row.data.value.url">{{ row.data.value.full_name }}</router-link>
				<span v-if="row.data.title == 'Формула'" v-html="model_formula"></span>
			</template>
		</biTable>

		<b-table class="mt-2" :items="attrs_factors" :fields="attrs_factors_fields">

			<template v-slot:cell(value)="data">

				{{ get_attr_factor_value(version, data.item.key) }}

			</template>

		</b-table>

	</myframe>

</template>

<script>

import api from "../../../../../api"
import variables from "../../../../../api/variables"
import myframe from "../../../../widgets/frame"
import biTable from "../../../../widgets/bi-table"

export default
{
	props :
	{
		version : Object,
		attrs : Array,
	},

	components :
	{
		myframe,
		biTable
	},

	computed:
	{
		rows() {
			return [
				{ title: 'Метод', value : this.version.group.cost_evaluation_comparative.type },
				{ title: 'УПКС', value : api.format_cost(this.version.attrs.UPKS_comparative) },
				{ title: 'Кадастровая стоимость', value : api.format_cost(this.version.attrs.cost_comparative) },
				{ title: 'Модель', value : this.version.group.cost_evaluation_comparative.modeling.type },
				{ title: 'Формула', value : this.model_formula, params : true },
				{
					title: 'Модель оценки КС',
					value :
					{
						url : '/cost_evaluations/' + this.version.group.id + '/comparative',
						full_name : 'Сравнительный подход'
					},
					params : true
				},
			]
		},

		model_formula()
		{
			let modeling = this.version.group.cost_evaluation_comparative.modeling
			return modeling.printable_formula_html[variables.CE_modeling_model.getCodeByName(modeling.type)]
		},

		attrs_factors()
		{
			let rows = []
			
			this.version.group.cost_evaluation_comparative.modeling.attrs.forEach(attr => {
				rows.push({ ...attr, ind : this.version.group.cost_evaluation_comparative.modeling.attrs_indexes[attr.id] })
			})

			return rows
		},
	},

	data()
	{
		return {

			attrs_factors_fields :
			[
				{ key : "ind", label : "X", },
				{ key : "name", label : "Название", },
				{ key : "value", label : "Значение" },
			],

		}
	},

	methods :
	{

		get_attr_factor_value(obj, key)
		{
			var value = api.get_attr_value(this.attrs, obj, key)

			if(typeof value === "string")
				value = value.trim()

			if(this.version.group.system.cost_evaluation_params)
			{
				const translated_value = this.version.group.system.cost_evaluation_params[key.split(".")[1]]

				if(translated_value)
					value += " ( " + translated_value[value] + " )"
			}

			return value
		},
	}
}

</script>

